var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"cookiebanner"}},[(_vm.show)?_c('div',{staticClass:"cookie-banner"},[_c('div',{staticClass:"container"},[_vm._t("default",null,null,{ close: _vm.close })],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }